export default {
  lista: [],
  listaConvenio: [],
  listaInteressadoAluno: [],
  estaCarregando: false,
  paginaAtual: 1,
  order: '',
  direcao: '',
  totalItens: null,
  totalItensConvenio: null,
  totalItensInteressadoAluno: null,
  todosItensCarregados: false,
  todosItensCarregadosConvenios: false,
  todosItensCarregadosInteressadoAluno: false,
  itemSelecionadoID: null,
  itemSelecionado: {
    id: null
  },
  filtros: null
}
